
    import '/home/runner/work/GPT-Vis/GPT-Vis/src/Table/index.en.md?watch=parent';
    export const demoIndex = {
  ids: ["table-demo-common","table-demo-markdown"],
  getter: () => import(/* webpackChunkName: "meta__Table__en" */'/home/runner/work/GPT-Vis/GPT-Vis/src/Table/index.en.md?type=demo')
};